import { apiPrefix } from "@/config/config";
import { api } from "../interceptor/api.interceptor";

class HomePageService {
  static async getSiteSetting() {
    return await api
      .get(`/${apiPrefix}/sitesetting`)
      .then((res) => res?.data?.data);
  }
  static async getBannerFeatures() {
    return await api
      .get(`/${apiPrefix}/banner_features`)
      .then((res) => res?.data?.data);
  }
  static async getPrograms() {
    return await api
      .get(`/${apiPrefix}/programs`)
      .then((res) => res?.data?.data);
  }

  static async getServices() {
    return await api
      .get(`/${apiPrefix}/services`)
      .then((res) => res?.data?.data);
  }

  static async getServiceDetails(slug) {
    return await api
      .get(`/${apiPrefix}/services/${slug}`)
      .then((res) => res?.data?.data);
  }

  static async getAllCourses() {
    return await api
      .get(`/${apiPrefix}/courses`)
      .then((res) => res?.data?.data);
  }

  static async getCourseSubjects(id) {
    return await api
      .get(`/${apiPrefix}/course/${id}/subjects`)
      .then((res) => res?.data?.data);
  }

  static async getCoursesByProgram(slug, page = 1) {
    return await api
      .get(`/${apiPrefix}/programs/${slug}/courses`, {
        params: { page },
      })
      .then((res) => res?.data?.data);
  }
  static async getProgramWiseCourses(params) {
    return await api
      .get(`/${apiPrefix}/programWiseCourses`, { params })
      .then((res) => res?.data?.data);
  }

  static async getVideosStories() {
    return await api
      .get(`/${apiPrefix}/video-stories`)
      .then((res) => res?.data?.data);
  }

  static async getFaqsCategories() {
    return await api
      .get(`/${apiPrefix}/faq-categories`)
      .then((res) => res?.data?.data);
  }

  static async getFaqs(categoryId) {
    return await api
      .get(`/${apiPrefix}/faqs/${categoryId}`)
      .then((res) => res?.data?.data);
  }

  // new services

  static async getAllGroup() {
    return await api
      .get(`/${apiPrefix}/getAllGruop`)
      .then((res) => res?.data?.data);
  }

  static async getGroupCourses(slug, params = {}) {
    return await api
      .get(`/${apiPrefix}/group/${slug}/courses`, { params })
      .then((res) => res?.data?.data);
  }

  static async getServices() {
    return await api
      .get(`/${apiPrefix}/services`)
      .then((res) => res?.data?.data);
  }

  static async getSuccessStories(params) {
    return await api
      .get(`/${apiPrefix}/success-stories`, { params })
      .then((res) => res?.data?.data);
  }

  static async getSuccessSliders() {
    return await api
      .get(`/${apiPrefix}/success-sliders`)
      .then((res) => res?.data?.data);
  }

  static async getVideoStories() {
    return await api
      .get(`/${apiPrefix}/video-stories`)
      .then((res) => res?.data?.data);
  }

  static async getStudentReview(params) {
    return await api
      .get(`/${apiPrefix}/student-review`,{params})
      .then((res) => res?.data?.data);
  }

    static async getStudentReviewDetails(id) {
    return await api
      .get(`/${apiPrefix}/student-review/${id}`)
      .then((res) => res?.data?.data);
  }

  static async getUniversities(page = 1, perPage = 10) {
    return await api
      .get(`/${apiPrefix}/universities`, {
        params: { page, per_page: perPage },
      })
      .then((res) => res?.data?.data)
      .catch((error) => {
        console.error("Error fetching universities:", error);
        return [];
      });
  }

      static async getUniversityDetails(slug) {
    return await api
      .get(`/${apiPrefix}/universities/${slug}`)
      .then((res) => res?.data?.data);
  }

}

export default HomePageService;
